// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const INSERT_RESULT_URL_IN_DOCUMENT_STEP_SHAPES = [
  {
    stepType: PipelineStepType.INSERT_RESULT_URL_IN_DOCUMENT,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Result URL': {
        systemName: 'Result URL',
        displayName: 'Result URL',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {},
    config: {
      documentId: {
        kind: 'domain',
        required: true,
        types: [
          'ENTRY',
          'DOCUMENT',
          'WORKSHEET'
        ]
      },
      sectionIndex: {
        kind: 'integer',
        required: false
      },
      linkText: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
